import React, { useState, useEffect } from "react";

import Notifycontent from "../../components/notification/notifycontent";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Spinner from "../../components/Spinner/spinner";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
const Notification = () => {
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    const token_horoscope = localStorage.getItem(
      `${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`,
    );
    if (!token && !token_horoscope) {
      navigate("/signin", { replace: true });
    }
  }, []);
  const datanotif = [
    {
      total: 0,
      data: [
        {
          id: "1",
          type: "Email",
          title: "Accountant",
          status: "Sent",
          date: "2008-11-28",
        },

        {
          id: "2",
          type: "SMS",
          title: "Accountant",
          status: "In progress",
          date: "2008-11-13",
        },
      ],
    },
  ];

  useEffect(() => {
    const start = Date.now();

    const spinnerTimeout = setTimeout(() => {
      setShowSpinner(true);
    }, 500);

    const fetchTimeout = setTimeout(() => {
      setLoading(false);
      const elapsed = Date.now() - start;
      if (elapsed < 500) {
        clearTimeout(spinnerTimeout);
      }
    }, 2000);

    return () => {
      clearTimeout(spinnerTimeout);
      clearTimeout(fetchTimeout);
    };
  }, []);

  return (
    <>
      {loading ? (
        showSpinner && <Spinner />
      ) : (
        <div className="row m-0">
          <Notifycontent data={datanotif[0].data} />
        </div>
      )}
    </>
  );
};

export default Notification;
